import { inject, Injectable } from '@angular/core';
import { isNil } from 'lodash';
import { environment } from '../../../environments/environment';
import { LanguageService } from '../../core/services/language.service';

// TODO: Analyze all usages number formatting (dimension service, measure service, RoundToOneDecimalPipe, DecimalPipe, etc.)
// and implement a solution that reuse this service instead of creation a many logic duplicates in different places
@Injectable({
  providedIn: 'root',
})
export class FormatService {
  private languageService = inject(LanguageService);

  public formatNumber(
    value: number | string | null | undefined,
    precisionDigits: number = environment.DIGITS_PRECISION_DEFAULT
  ): string | null {
    if (isNil(value) || value === '') {
      return null;
    }

    const parsedValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(parsedValue)) {
      return null;
    }

    const minimumFractionDigits = Number.isInteger(parsedValue) ? 0 : precisionDigits;
    const maximumFractionDigits = precisionDigits;

    return new Intl.NumberFormat(this.languageService.getCurrentLocale(), {
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(parsedValue);
  }
}
